// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WKrYvEw\\+3-dGWDFWOru6Og\\=\\= li:first-child{position:sticky;top:0;z-index:1}", "",{"version":3,"sources":["webpack://./src/components/MultiDropdown/subcomponents/SubDropdownWithSearch/SubDropdownWithSearch.module.scss"],"names":[],"mappings":"AAAA,4CACE,eAAA,CACA,KAAA,CACA,SAAA","sourcesContent":[".searchBar li:first-child {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchBar": "WKrYvEw+3-dGWDFWOru6Og=="
};
export default ___CSS_LOADER_EXPORT___;
